import { useTranslation } from 'react-i18next'
import type { ExpiringNext } from '../../hooks/credits/useCreditBalance'
import { formatExpiringNextDate } from './creditExpiryDisplay'

type Variant = 'badge' | 'hero'

interface ExpiringNextNoticeProps {
  expiring: ExpiringNext
  variant?: Variant
  className?: string
}

/**
 * Validity-only: how many points die on the global soonest expiry.
 * Do not pass source buckets here — provenance is {@link BalanceSourceBreakdown}.
 */
export function ExpiringNextNotice({
  expiring,
  variant = 'badge',
  className = '',
}: ExpiringNextNoticeProps) {
  const { t, i18n } = useTranslation('credits')
  if (expiring.points <= 0) return null

  const date = formatExpiringNextDate(expiring, i18n.language)
  if (!date) return null

  const points = expiring.points.toLocaleString()

  if (variant === 'hero') {
    return (
      <div className={`text-right text-sm opacity-80 ${className}`}>
        <p>{t('page.nearestExpiry')}</p>
        <p className="font-semibold">{date}</p>
        <p className="mt-0.5 text-xs opacity-90">
          {t('page.expiringNextPoints', { count: expiring.points, points })}
        </p>
      </div>
    )
  }

  return (
    <div className={`pt-2 border-t border-gray-100 ${className}`}>
      <div className="text-xs font-semibold text-gray-500 mb-1">
        {t('page.nearestExpiry')}
      </div>
      <div className="text-xs text-amber-600">
        {t('balance.breakdown.soonestExpiryWithPoints', { points, date })}
      </div>
    </div>
  )
}
